import { useEffect, useRef, useState } from "react";

type Milliseconds = number;

export function useDebounced<T>(value: T, time: Milliseconds): T {
  const [state, setState] = useState(value);
  const timeoutHandle = useRef<number>(undefined);
  useEffect(() => {
    clearTimeout(timeoutHandle.current);
    timeoutHandle.current = setTimeout(() => setState(value), time);
  }, [value]); // oxlint-disable-line exhaustive-effect-dependencies -- time is not relevant here
  return state;
}
